export const MARKETING_TIP_SOURCE = 'marketing-tips';

interface MarketingTipCheckResponse {
  fromMarketingTips: boolean;
  serviceId?: number;
}

export function checkFromMarketingTips(
  routeParams: Record<string, string | boolean>,
): MarketingTipCheckResponse {
  const numericServiceId = Number(routeParams?.serviceId);

  const result: MarketingTipCheckResponse = {
    fromMarketingTips: routeParams?.source === MARKETING_TIP_SOURCE,
    serviceId: !Number.isNaN(numericServiceId) ? numericServiceId : undefined,
  };

  return result;
}
